/**
 * NinjaTrader Vendor Program — brand attribution text. English verbatim per
 * the Vendor Compliance Guidelines — do NOT edit or translate.
 *
 * Pure-TS module (no JSX) so server code (SSR SEO body) can import it without
 * pulling a React component into the server bundle. The UI component
 * <NinjaTraderTrademarkNotice> re-exports it.
 */
export const NINJATRADER_TRADEMARK_TEXT =
  "NinjaTrader® is a registered trademark of NinjaTrader Group, LLC. No NinjaTrader company has any affiliation with the owner, developer, or provider of the products or services described herein, or any interest, ownership or otherwise, in any such product or service, or endorses, recommends or approves any such product or service.";
